import { AlternativePricingPlan } from "../../../types/hubInterfaces";
import { PricePlan, UserPricingPlan } from "../../../types/hubTypes";

export const calculatePlanDiscount = (currentPlan: UserPricingPlan, newPlan: AlternativePricingPlan | PricePlan) => {
    const currentPrice = currentPlan?.privatePriceTier?.costPerSession;
    const upcomingPrice = newPlan?.privatePriceTier?.costPerSession;
    if (!currentPrice || !upcomingPrice) return 0;
    return Math.round(((currentPrice - upcomingPrice) / currentPrice) * 100);
};